import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Landing from './components/Landing';
import Login from './components/Login';
import Signup from './components/SignUp';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Dashboard from './components/Dashboard';
import Profile from './components/Profile';
import Quotes from './components/Quotes';
import QuoteDetail from './components/QuoteDetail';
import PublicQuote from './components/PublicQuote';
import Clients from './components/Clients';
import Invoices from './components/Invoices';
import InvoiceDetail from './components/InvoiceDetail';
import Expenses from './components/Expenses';
import Navbar from './components/Navbar';
import ServiceDesk from './components/ServiceDesk';
import { THEME } from './constants/theme';
import './styles/fonts.css';
import PublicInvoice from './components/PublicInvoice';
import QuoteInteractionScreen from './screens/QuoteInteractionScreen';
import InvoiceInteractionScreen from './screens/InvoiceInteractionScreen';
import TradeHub from './screens/TradeHub';
import { LoadScript } from '@react-google-maps/api';
import ChangePassword from './components/ChangePassword';
import Documentation from './components/Documentation';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import Support from './components/Support';
import About from './components/About';
const libraries = ['places'];

function AppContent() {
  const { user } = useAuth();
  const onSignOut = useAuth().signOut;

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/quote/:id" element={
        <div className="min-h-screen" style={{ backgroundColor: THEME.background }}>
          {user && <Navbar />}
          <PublicQuote />
        </div>
      } />
      <Route path="/invoice/:id" element={<PublicInvoice />} />
      <Route path="/tradehub" element={<TradeHub />} />
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/docs" element={<Documentation />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/support" element={<Support />} />
      <Route path="/about" element={<About />} />

      {/* Protected Routes */}
      <Route path="/*" element={
        <div className="min-h-screen" style={{ backgroundColor: THEME.background }}>
          {user ? (
            <>
              <Navbar user={user} onSignOut={onSignOut} />
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/quotes" element={<Quotes />} />
                <Route path="/quotes/new" element={<QuoteDetail />} />
                <Route path="/quotes/:id" element={<QuoteDetail />} />
                <Route path="/quotes/:id/interactions" element={<QuoteInteractionScreen />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/invoices" element={<Invoices />} />
                <Route path="/invoices/new" element={<InvoiceDetail />} />
                <Route path="/invoices/:id" element={<InvoiceDetail />} />
                <Route path="/invoices/:id/interactions" element={<InvoiceInteractionScreen />} />
                <Route path="/expenses" element={<Expenses />} />
                <Route path="/service-desk" element={<ServiceDesk />} />
              </Routes>
            </>
          ) : (
            <Login />
          )}
        </div>
      } />
    </Routes>
  );
}

function App() {
  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={libraries}>
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
    </LoadScript>
  );
}

export default App;
